export const ERROR_MESSAGE_MAX_SIZE = "Please resize your image less then 1MB"
export const ERROR_MESSAGE_FAILED = "Upload image failed"
